import Dexie, { type EntityTable } from 'dexie'

interface LocalUserContext {
  id: number // This prop will be used as primary key (see below)
  prevContext: string
  userInput: string
  encryptKey: string
}

interface LocalMomentsChunks {
  id: number
  textToEmbed: string
  momentId: string
  encryptKey: string
}

interface LocalMomentTagsAndEmotions {
  id: number
  momentId: string
  content: string
}

interface LocalMomentImages {
  id: number
  momentId: string
  order: number
  encryptKey: string
  media: Blob
  type: string
  fileName: string
}

const db = new Dexie('MomentsDB') as Dexie & {
  userContext: EntityTable<LocalUserContext, 'id'>
  momentsChunks: EntityTable<LocalMomentsChunks, 'id'>
  momentTagsAndEmotions: EntityTable<LocalMomentTagsAndEmotions, 'id'>
  momentImages: EntityTable<LocalMomentImages, 'id'>
}

// Schema declaration:
db.version(1).stores({
  userContext:
    '++id, prevContext, userInput, userId, userSettingsId, encryptKey, jwt',
  momentsChunks: '++id, textToEmbed, userId, momentId, encryptKey, jwt',
  momentTagsAndEmotions: '++id, momentId, content, tags, jwt',
  momentImages: '++id, momentId, media, type, order, fileName, userId, jwt',
})

export type {
  LocalUserContext,
  LocalMomentsChunks,
  LocalMomentTagsAndEmotions,
  LocalMomentImages,
}
export { db }
